const vacation = {
  'vacation.title': 'Vacation management',
  'vacation.request': 'Request vacation',
  'vacation.entitlement': 'Vacation entitlement {year}',
  'vacation.total': 'Total',
  'vacation.used': 'Used',
  'vacation.planned': 'Planned',
  'vacation.available': 'Available',
  'vacation.used.title': 'Used: {days}',
  'vacation.planned.title': 'Planned: {days}',
  'vacation.form.title': 'New vacation request',
  'vacation.form.from': 'From',
  'vacation.form.to': 'To',
  'vacation.form.notes': 'Comment (optional)',
  'vacation.form.submit': 'Submit',
  'vacation.form.cancel': 'Cancel',
  'vacation.status.PENDING': 'Pending',
  'vacation.status.APPROVED': 'Approved',
  'vacation.status.REJECTED': 'Rejected',
  'vacation.my.title': 'My vacation requests',
  'vacation.col.from': 'From',
  'vacation.col.to': 'To',
  'vacation.col.days': 'Days',
  'vacation.col.status': 'Status',
  'vacation.col.substitute': 'Substitute',
  'vacation.col.notes': 'Comment',
  'vacation.col.reason': 'Reason',
  'vacation.col.submitted': 'Submitted',
  'vacation.col.employee': 'Employee',
  'vacation.col.actions': 'Actions',
  'vacation.empty': 'No requests found',
  'vacation.team.title': 'My team’s vacation requests',
  'vacation.team.open': '{count} open',
  'vacation.user.fallback': 'User #{id}',
  'vacation.approve': 'Approve',
  'vacation.reject': 'Reject',
  'vacation.prompt.approve': 'Reason (optional):',
  'vacation.prompt.reject': 'Reason for rejection (required):',
  'vacation.error.submit': 'Error submitting the request',
  'vacation.error.approve': 'Error approving the request',
  'vacation.error.reject': 'Error rejecting the request',
  'vacation.move': 'Move',
  'vacation.move.title': 'Move vacation',
  'vacation.move.save': 'Move',
  'vacation.move.hint': 'New period for the request of {name}.',
  'vacation.move.error': 'The request could not be moved',
  'vacation.delete': 'Delete',
  'vacation.delete.confirm': 'Really delete the approved request of {name} ({from} – {to})? Booked days will be refunded.',
  'vacation.delete.error': 'The request could not be deleted',
  'vacation.substitute.reapprovalHint': 'Note: This request is already approved. Changing the substitute requires a new approval and sets it back to "Pending".',
  'vacation.substitute.reapprovalConfirm': 'The request must be approved again after changing the substitute. Continue?',
  'vacation.substitute.pick': 'Select substitute…',
  'vacation.substitute.set': 'Set substitute',
  'vacation.substitute.unavailable': '{name} (unavailable: {reason})',
  'vacation.substitute.save': 'Save',
  'vacation.substitute.cancel': 'Cancel',
  'vacation.substitute.none': 'No team members available',
  'vacation.form.substitute': 'Substitute',
  'vacation.form.substituteRequired': 'Substitute (required)',
  'vacation.form.substituteOptional': 'Substitute (optional)',
  'vacation.form.substituteMandatoryHint': 'Your team requires a substitute from the team for vacation requests.',
  'vacation.form.substitutePickDates': 'Select a period to see suggestions',
  'vacation.substitute.error.load': 'Suggestions could not be loaded',
  'vacation.substitute.error.save': 'Substitute could not be saved',
};

export default vacation;
